import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Navbar */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-12 flex items-center justify-between h-14 md:h-20">
          <span className={`font-black text-base md:text-lg tracking-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            TRANSFORMAÇÃO REAL <span className="text-amber-400">60D</span>
          </span>
          <button
            onClick={scrollToForm}
            className={`whitespace-nowrap text-xs md:text-sm font-semibold px-4 py-2 md:px-5 md:py-2.5 rounded-full transition-all cursor-pointer ${
              scrolled
                ? 'bg-gray-900 text-white hover:bg-gray-700'
                : 'bg-white/20 text-white border border-white/40 hover:bg-white/30'
            }`}
          >
            Garantir Minha Vaga
          </button>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-gray-950">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_5d99c3b6aea93f777df3844a89ec72b3_959f80c1.jpg"
            alt="Consultoria empresarial presencial"
            className="w-full h-full object-cover opacity-85"
            style={{ objectPosition: '100% center' }}
          />
          {/* Mobile: escurece mais pra texto ficar legível */}
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/90 to-transparent" />
          <div className="absolute inset-0 bg-gray-950/50 md:bg-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12 w-full pt-20 md:pt-24 pb-12 md:pb-20">
          {/* Conteúdo principal */}
          <div className="max-w-xl md:max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1.5 md:px-4 md:py-2 mb-6 md:mb-10">
              <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-amber-400 animate-pulse" />
              <span className="text-white/80 text-xs font-medium tracking-widest uppercase">
                Programa Presencial · Manaus/AM
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-white leading-[1.05] mb-6 md:mb-8">
              A MAIORIA DAS<br />
              EMPRESAS NÃO<br />
              QUEBRA POR FALTA<br />
              <span className="text-amber-400">DE CLIENTES.</span>
            </h1>

            <p className="text-base md:text-2xl text-white/70 font-light mb-3 md:mb-4 leading-relaxed">
              Quebra por falta de estrutura.
            </p>
            <p className="text-base md:text-2xl text-white/70 font-light mb-8 md:mb-12 leading-relaxed">
              E isso pode mudar em <strong className="text-white font-semibold">60 dias.</strong>
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-start gap-3">
              <button
                onClick={scrollToForm}
                className="whitespace-nowrap inline-flex items-center justify-center gap-3 bg-amber-400 hover:bg-amber-300 text-gray-900 font-bold text-sm md:text-base px-6 md:px-8 py-4 rounded-full transition-all cursor-pointer"
              >
                QUERO TRANSFORMAR MINHA EMPRESA
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center bg-gray-900 rounded-full flex-shrink-0">
                  <i className="ri-arrow-right-line text-amber-400 text-sm" />
                </span>
              </button>
            </div>
            <p className="text-white/40 text-xs md:text-sm mt-3 md:mt-4">
              8 sessões presenciais + 8 online · Vagas limitadas por ciclo
            </p>
          </div>

          {/* Powered by logo */}
          <div className="mt-8 md:mt-[-96px] mb-0 flex justify-start md:justify-end items-center gap-3">
            <span className="text-white/40 text-xs font-medium tracking-widest uppercase">Powered by:</span>
            <img
              src="/powered-by-logo.png"
              alt="Logo parceiro"
              className="h-10 md:h-16 w-auto object-contain opacity-85"
            />
          </div>

          {/* Stats row */}
          <div className="mt-8 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            {[
              { value: '60', label: 'Dias de programa' },
              { value: '8+8', label: 'Presencial + Online' },
              { value: '2x', label: 'Por semana' },
              { value: '70%', label: 'Aplicação prática' },
            ].map((stat) => (
              <div key={stat.label} className="border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-5 bg-white/5 backdrop-blur-sm">
                <div className="text-2xl md:text-4xl font-black text-amber-400 mb-1">{stat.value}</div>
                <div className="text-white/60 text-xs md:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
